export const CarrierTypeName = {
  DTG: 'DeliverThis',
  UPS: 'UPS',
  ES: 'Estefa',
  FDEG: 'FedEx',
  FEDRH: 'FedEx',
};
